export default {
  Single: 4,
  Divorcee: 6,
  Widow: 8,
};
